import { Component } from '@angular/core';
import {CHAR_STRUCT, CHAR_TYPE} from "../../shared/defines/client.const";
import {WordDispComponent} from "../../shared/components/word-disp/word-disp.component";

@Component({
  selector: 'app-homonym-word-disp',
  styleUrls: ['../../shared/components/word-disp/word-disp.component.scss'],
  template: `
    <article class="keyword-layout {{ class ?? '' }}"
             #container
             *ngIf="word">

      <div class="keyword-wrap">

        <div class="group"
             *ngFor="let cs of word?.wordStruct; let idx = index">
          <div class="row top {{ GetSeungjoClass(cs) }}">
            <div *ngIf="IsShowSeungjo(cs)"
                 class="ic {{ GetSeungjoClass2(cs) }}"></div>
          </div>
          <div class="row txt {{ GetCharClass(cs) }} {{ GetHightlightClass(idx) }}">{{ GetCharTxt(cs) }}</div>
        </div>

        <div class="group" *ngIf="word.idxHomonym > 0">
          <div class="row top"></div>
          <div class="row txt idx-homonym">{{ word.idxHomonym }}</div>
        </div>

      </div>
    </article>
  `,
})
export class HomonymWordDispComponent extends WordDispComponent{

  public override GetCharClass(cs: CHAR_STRUCT): string {
    switch (cs.type) {
      case CHAR_TYPE.HANJA:
        return 'cn';
      case CHAR_TYPE.JANGDAN:
        return cs.char === '/' ? 'small type-2' : 'small';
    }
    // return 'ff-miwon';
    return '';
  }
}
